// extracted by mini-css-extract-plugin
module.exports = {"meals":"Meals_meals__6d0Yj"};